export class SmartSuggestionMetaStateModel {
  isAlertOpen: boolean
  warnings: IWarning[]
  isWarningModalOpen: boolean
  compositionSuggestions?: ICompositionSuggestion
  version: string
}

export interface ICompositionSuggestion {
  panels: ISingleSuggestion[]
  inverters: ISingleSuggestion[]
  brackets: ISingleSuggestion[]
  protections: ISingleSuggestion[]
  connectors: ISingleSuggestion[]
  cables: ISingleSuggestion[]
  accessories: ISingleSuggestion[]
}

export interface ISingleSuggestion {
  title: string
  isSelected: boolean
  content: IContentSuggestion[]
}

export interface IContentSuggestion {
  id: any
  type: ProductTypes
  quantity: any
  portsNumber?: number
  title?: string
}

export enum WarningReferences {
  MACRO_CONSTRAINTS_EMPTY_PANELS = 'MACRO_CONSTRAINTS_EMPTY_PANELS',
  MACRO_CONSTRAINTS_EMPTY_INVERTERS = 'MACRO_CONSTRAINTS_EMPTY_INVERTERS',
  MACRO_CONSTRAINTS_EMPTY_PANELS_AND_INVERTERS = 'MACRO_CONSTRAINTS_EMPTY_PANELS_AND_INVERTERS',
  PANEL_X_INVERTER_NOT_MATCHED = 'PANEL_X_INVERTER_NOT_MATCHED',
  PROTECTION_X_INVERTER_MISSING_REQUIRED_PROTECTIONS = 'PROTECTION_X_INVERTER_MISSING_REQUIRED_PROTECTIONS',
  PANEL_X_BRACKETS_MISSING_REQUIRED_BRACKETS = 'PANEL_X_BRACKETS_MISSING_REQUIRED_BRACKETS',
  PANEL_X_BRACKETS_MISSING_REQUIRED_ACCESSORIES = 'PANEL_X_BRACKETS_MISSING_REQUIRED_ACCESSORIES',
  INVERTER_X_ACCESSORIES_MISSING_REQUIRED_ACCESSORIES = 'INVERTER_X_ACCESSORIES_MISSING_REQUIRED_ACCESSORIES',
}

export enum WarningActions {
  GO_TO_PANELS_TAB = 'GO_TO_PANELS_TAB',
  GO_TO_INVERTERS_TAB = 'GO_TO_INVERTERS_TAB',
  SEE_SUGGESTIONS = 'SEE_SUGGESTIONS',
}

export interface IWarning {
  id?: string
  content: string
  productType?: ProductTypes
  isRestrictive: boolean
  lockedTabs: number[]
  options?: IWarningOptions[]
  reference: WarningReferences
}

export interface IWarningOptions {
  actions: WarningActions[]
  title: string
}

export enum ProductTypes {
  PANEL = 'PANEL',
  INVERTER = 'INVERTER',
  BRACKET = 'BRACKET',
  PROTECTION = 'PROTECTION',
  CONNECTOR = 'CONNECTOR',
  CABLE = 'CABLE',
  ACCESSORY = 'ACCESSORY',
  CHARGER = 'CHARGER',
}
